<template>
    <div class="container-fluid">
        <nav>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/mypage">マイページ</router-link></li>
                <li class="breadcrumb-item">お問い合わせ</li>
            </ol>
        </nav>
        <div class="container p-0">
            <div class="text-muted small p-2 my-2">
                不具合のご連絡やご要望、気になることなどが御座いましたら、
                お気軽にお問い合わせください。
            </div>
            <div class="text-right">
                <router-link to="/mypage/ticket/new" class="btn btn-outline-primary">
                    お問い合わせの新規追加
                </router-link>
            </div>
            <div class="sticky">
                <page :last_page="tickets.last_page" v-model="page" @goto="goto"></page>
            </div>
            <div class="my-2" v-if="tickets.total">
                <div class="card" v-for="t in tickets.data" :key="t.id">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <div>
                            <i class="fas fa-check" v-if="t.closed_at"></i>
                            <router-link :to="`/mypage/ticket/${t.id}`"
                                :class="{'text-muted': t.closed_at}">{{t.ticket_subject.subject}}</router-link>
                            <span class="badge badge-primary badge-pill" v-if="t.ticket_topics_count">
                                {{t.ticket_topics_count}} 件の返信
                            </span>
                        </div>
                        <span class="badge badge-secondary badge-pill" v-if="t.closed_at">
                            {{$filters.fromNow(t.closed_at)}} にクローズ
                        </span>
                    </div>
                    <div class="card-body">
                        <editor :content="$filters.jsonParse(t.topic)"
                            :id="'editor-' + t.id"
                            :readOnly="true"
                            :minHeight="0"
                            class="article"></editor>
                    </div>
                    <div class="card-footer text-right small">
                        <ul class="horizontal-list">
                            <li>{{$filters.dateFormat(t.created_at)}}</li>
                            <li v-if="t.closed_at">{{$filters.dateFormat(t.closed_at)}}にクローズ</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="nothing" v-else>
                お問い合わせはありません。
            </div>
        </div>
    </div>
</template>

<style scoped>
.card {
    margin: 2rem 0;
}
.closed {
    text-decoration: line-through;
}
</style>

<script>
import page from "components/Page";
export default {
    components: {
        page,
    },
    data() {
        return {
            page: 1,
            tickets: {},
        }
    },
    methods: {
        goto(p) {
            this.page = p;
            setTimeout(() => {this.load()});
        },
        load() {
            $("html,body").animate({scrollTop: 0}, 300);
            axios.get("/mypage/tickets/get", {params: {page: this.page}}).then(res => {
                this.tickets = res.data;
            }).catch(err => { alert.err(err.response) });
        }
    },
    mounted() {
        this.load();
        setTimeout(() => {
            this.useHead({
                title: "お問い合わせ | 貸し本棚",
                link: [ { rel: "canonical", href: location.origin + location.pathname, id: "canonical" } ],
                meta: [
                    { name: "keywords", content: "貸し本棚,小説投稿,Web小説,小説展示,オンライン小説,縦書き小説,置き場,文芸,ライトノベル", id: "meta-keywords" },
                    { name: "description", content: "小説を書くこと、読むことにフォーカスした小説投稿サイトです。作家さん独自のサブドメインで、ご自身の小説を公開できます。横断的に編集ができるエディタで原稿執筆することも、過去の作品をレーティングを気にせず展示することもできます。", id: "meta-description" }
                ]
            });
        }, 1000);
    }
}
</script>